import { Component, OnInit, NgZone, OnDestroy, ViewChild, ElementRef, HostListener, ChangeDetectionStrategy } from "@angular/core";
import {
  Download,
  BundledDownloads,
  Downloads,
  Product,
  ProductDetail,
  GetOemKeyResponse,
  ContentService,
  CheckoutService,
  ProductSnapshot,
  ProductListItem,
  ProductLicenseItem,
  MissingFenderSerial,
} from "@mypxplat/xplat/core";
import { BaseComponent, UserService, ProductService, HelperService, WindowService, GAService, environment, EventBusService, StorageService, StorageKeys } from "@mypxplat/xplat/core";
import { ActivatedRoute, Router, NavigationEnd, NavigationExtras } from "@angular/router";
import moment from "moment";
import {
  ActivateOfflineComponent,
  UpgradeSoftwareComponent,
  ManageActivationsComponent,
  RegisterProductComponent,
  FirmwareInstructionsComponent,
  IlokComponent,
  RedeemHardwareOfferComponent,
  RegisterSuccessSplashComponent,
  StudiooneGracePeriodComponent,
  GenericAlertComponent,
} from "../modals";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AppService, AvoService, BetaService, DiscordGiftService, FirebaseService } from "@mypxplat/xplat/web/core";
import natsort from "natsort";
import { saveAs } from "file-saver";
import { ClipboardService } from "ngx-clipboard";
import { filter, take, takeUntil } from "rxjs/operators";
import { ProductDownloadsComponent } from "../product-downloads/product-downloads.component";
import { format } from "date-fns";
import { BehaviorSubject, fromEvent, Subject } from "rxjs";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-shared-product-detail",
  templateUrl: "product-detail.component.html",
  standalone: false,
})
export class ProductDetailComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild("productDownloads") productDownloads: ProductDownloadsComponent;
  @ViewChild("prodDetailTitle") prodDetailTitle: ElementRef;
  @ViewChild("prodDetailHead") prodDetailHead: ElementRef;
  @ViewChild("prodDetailSidebar") prodDetailSidebar: ElementRef;
  @ViewChild("prodDescription") prodDescription: ElementRef;
  public snapshot: ProductSnapshot;
  public missingFenderSerial: MissingFenderSerial;
  public listProduct: ProductListItem;
  public product: any;
  public details: ProductDetail;
  public group: Array<Product>;
  public loading: boolean = false;
  public loadingLicenses: boolean = false;
  public selectedVideo: any = false;
  public selectedLicense: any;
  public downloadingLicense = false;
  public productImage: string;
  public hasThirdPartyKeys: boolean = false;
  public children: Array<Product>;
  public bundledProducts: Array<any>;
  public optionCards: Array<any>;
  public downloads: ProductSnapshot["downloads"];
  public downloadSections: Array<any>;
  public displayedDownloadSection: any;
  public resources: any;
  public resourcesSections: Array<any>;
  public displayedResourcesSection: any;
  public installFile: any;
  public s1OrNotion: boolean;
  public isS15: boolean;
  public isS16: boolean;
  public isS17: boolean;
  public isFSP8: boolean;
  public isFenderStudio: boolean;
  public showAllSystems: boolean = false;
  public myOs: string;
  public showKeyActions: boolean = true;
  public computerName: string;
  public routerEvents: any;
  public installMethods: Array<string>;
  public shouldShowSphereRedeem: boolean = false;
  public features: string;
  public featuresCollapsed: boolean = false;
  public samplesCollapsed: boolean = false;
  public downloadsCollapsed: boolean = false;
  public bundledProductsCollapsed: boolean = false;
  public resourcesCollapsed: boolean = false;
  public specsCollapsed: boolean = false;
  public allSpecs: any[];
  public showAllSpecs: boolean = false;
  public highlights: any[];
  // Amazon-style gallery: productImage (if any) plus every merged PIM image, deduped.
  // mainImageUrl is what the hero slot shows — hovering a thumbnail swaps it; clicking
  // either opens the fullscreen viewer at that image's index.
  public galleryImages: string[] = [];
  public mainImageUrl: string;
  public env = environment;
  public isNotionMobile: boolean;
  public viewingOffers: boolean = false;
  public hashFragment: string;
  public couponParam: string;
  public subscriptionOnly: boolean;
  public shouldBeSticky: boolean = false;
  public licenses: Array<ProductLicenseItem>;
  public gotLicenses$: BehaviorSubject<any> = new BehaviorSubject(false);
  public hasExtrasOrOffers: boolean = false;
  public canRedeemStudioOneSeven: boolean = false;
  public copiedThirdPartyKeyId: string | null = null;
  public copiedLicenseKeyId: string | null = null;

  public productPointVersion: string;
  public title: string;
  public subTitle: string;
  public displaySerialNumber: string;
  public productDescriptionHtml: string = "";
  // The description is admin-authored rich HTML that can run long; it's clamped to ~4 lines with a
  // Show more / Show less toggle. `descriptionOverflowing` gates whether the toggle is shown at all.
  public descriptionExpanded: boolean = false;
  public descriptionOverflowing: boolean = false;

  public extrasOffersCollapsed: boolean = false;
  public highlightsCollapsed: boolean = false;
  public crossSellCollapsed: boolean = false;
  // Cross-sell / "you might also like" products, resolved from pimSpecs.CrossSell SKUs and
  // bucketed by relationshipType into tabs. Each bucket's items feed myp-product-tile.
  public crossSellBuckets: Array<{ type: string; items: any[]; displayed: boolean }> = [];
  public displayedCrossSellBucket: { type: string; items: any[]; displayed: boolean } | undefined;

  public shouldShowFsAmpPackCallout: boolean = false;
  public eligibleFsAmpPackStringIdsWithDateRestriction = ["FENDERQUANTUMHD2", "FENDERQUANTUMHD8", "FENDERQUANTUMLT16", "FENDERQUANTUMCREATOR", "FENDERQUANTUMCOMPLETE"];
  public eligibleFsAmpPackStringIds = ["FENDERQUANTUMLT2", "FENDERQUANTUMLT4", "FENDERAUDIOBOXGO"];
  constructor(
    userService: UserService,
    public discordGift: DiscordGiftService,
    private _route: ActivatedRoute,
    public eventBusService: EventBusService,
    public productService: ProductService,
    public helperService: HelperService,
    public appService: AppService,
    private _zone: NgZone,
    public win: WindowService,
    private router: Router,
    public ga: GAService,
    private _translate: TranslateService,
    private _spin: NgxSpinnerService,
    public db: AngularFirestore,
    private _clipboardService: ClipboardService,
    public contentService: ContentService,
    public betaService: BetaService,
    public avoService: AvoService,
    public fbService: FirebaseService,
    public checkoutService: CheckoutService,
    public storage: StorageService
  ) {
    super(userService);
  }

  /**
   * The paid offers actually shown. Same as the raw list, minus any Fender Studio Pro offer
   * when the member can claim it free from the Discord migration — `fui-discord-free-fsp-offer`
   * takes its place. Rebuilt rather than filtered in the template so change detection is not
   * running a filter every cycle.
   */
  public displayedPromotions: any[] = [];

  ngOnInit() {
    this.myOs = this.win.navigator.platform.indexOf("Mac") > -1 ? "mac" : "win";
    // Cached across surfaces; re-filter whenever it lands, since the snapshot and this answer
    // arrive independently.
    this.discordGift.load().subscribe({
      next: () => this._applyDisplayedPromotions(),
      error: () => {},
    });
    let id = this._route.snapshot.params["id"];
    if (id.startsWith("0")) id = id.slice(1); // this is for fender product skus that start with 0.
    const urlTree = this.router.parseUrl(this.router.url);
    this.hashFragment = urlTree.fragment;
    this.initView(id);
    this.routerEvents = this.router.events.subscribe((result) => {
      // this allows you to "navigate" to another product detail from this page
      if (result instanceof NavigationEnd) {
        this.initView(this._route.snapshot.params["id"]);
        this.measureUI();
      }
    });

    fromEvent(window, "scroll", { passive: true }).subscribe(() => {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      this.shouldBeSticky = scrollTop > 85;
    });

    // Re-resolve localized copy when the user switches languages — without refetching the base
    // snapshot (the admin-authored maps already ride on snapshot.metadata); also try a localized
    // PIM overlay for the newly selected locale.
    this._translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (!this.snapshot?.product) return;
      this.productDescriptionHtml = this.resolveDescriptionHtml();
      this.maybeApplyLocalizedPim();
    });
  }

  /**
   * Resolves the product description HTML for the active locale with per-field English fallback.
   * Prefers an admin-authored override (snapshot.metadata.descriptions[lang]), then authored
   * English, then the product's own (English) description — which may itself have been replaced by
   * localized PIM copy via {@link maybeApplyLocalizedPim}.
   */
  private resolveDescriptionHtml(): string {
    const lang = this._translate.currentLang || this._translate.defaultLang || "en";
    const descriptions = this.snapshot?.metadata?.descriptions;
    const source = descriptions?.[lang] || descriptions?.en || this.snapshot?.product?.description || "";
    return source ? this.helperService.convertLineBreaks(source) : "";
  }

  /**
   * When the active language is non-English and there is no admin-authored localized description,
   * but the product has PIM data (fmic_material_number), fetch localized PIM copy and overlay the
   * localizable fields (description, shortDescription, pimSpecs). Read-only: never persists a
   * snapshot; PIM falls back to English server-side, so untranslated fields simply stay English.
   */
  private maybeApplyLocalizedPim() {
    if (!this.snapshot?.product) return;
    const lang = this._translate.currentLang || this._translate.defaultLang || "en";
    const hasAdminOverride = !!this.snapshot.metadata?.descriptions?.[lang];
    if (lang === "en" || hasAdminOverride || !this.snapshot.product.fmic_material_number) return;
    this.productService.getLocalizedProductSnapshot(this.snapshot.product.id, lang).subscribe({
      next: (localized: any) => {
        if (!localized?.product || !this.snapshot?.product) return;
        if (localized.product.description) this.snapshot.product.description = localized.product.description;
        if (localized.product.shortDescription) this.snapshot.product.shortDescription = localized.product.shortDescription;
        if (localized.pimSpecs) this.snapshot.pimSpecs = localized.pimSpecs;
        this.applyLocalizedDerived();
      },
      error: () => {
        /* keep the English snapshot on failure */
      },
    });
  }

  /** Recomputes the description + PIM-derived UI (title/subtitle, specs, highlights) after overlay. */
  private applyLocalizedDerived() {
    this.productDescriptionHtml = this.resolveDescriptionHtml();
    const isFenderOnlySnapshot = Number(this.snapshot.product?.id) >= 10000;
    if (isFenderOnlySnapshot && this.snapshot.pimSpecs?.general?.Series) {
      this.title = this.snapshot.pimSpecs.general.Series;
      if (this.snapshot.pimSpecs.body?.["Body Shape"]) this.title += " " + this.snapshot.pimSpecs.body["Body Shape"];
    }
    if (isFenderOnlySnapshot && this.snapshot.pimSpecs?.general?.Color) {
      this.subTitle = this.snapshot.pimSpecs.general.Color;
      if (this.snapshot.pimSpecs.body?.["Body Finish"]) this.subTitle += ", " + this.snapshot.pimSpecs.body["Body Finish"];
    }
    this.allSpecs = [];
    if (this.snapshot.pimSpecs) {
      for (const key in this.snapshot.pimSpecs) {
        const section = (this.snapshot.pimSpecs as any)[key];
        if (section && typeof section === "object" && !Array.isArray(section) && section.Name) this.allSpecs.push(section);
      }
    }
    this.highlights = Array.isArray(this.snapshot.pimSpecs?.Highlights) ? this.buildHighlightsFromSpecs(this.snapshot.pimSpecs.Highlights) : undefined;
  }

  redeemPromotion(promo: any) {
    this.storage.setItem(StorageKeys.CHECKOUT_COUPONS, [promo.coupon_code]);
    // Persist the promotion's discount magnitude so checkout can compare it against the
    // auto-apply active offer and favor the better deal.
    this.storage.setItem(StorageKeys.PROMOTION_COUPON, {
      code: promo.coupon_code,
      percent_off: promo.coupon?.percent_off || 0,
      amount_off: promo.coupon?.amount_off || 0,
      currency: promo.coupon?.currency || null,
    });
    const sphereIds = [this.env.product_ids.sphere_monthly, this.env.product_ids.sphere_annual];
    if (sphereIds.includes(promo.offer_product?.product?.id)) {
      const term = promo.offer_product.product.id === this.env.product_ids.sphere_monthly ? "monthly" : "annual";
      this.appService.goToCheckout("/checkout?term=" + term);
    } else {
      this.appService.goToCheckout("/checkout?checkoutProductType=Perpetual");
    }
  }

  ngOnDestroy() {
    if (this.routerEvents && this.routerEvents.unsubscribe) this.routerEvents.unsubscribe();
    super.ngOnDestroy();
  }

  /** See `displayedPromotions`. Called when either the offers or the eligibility answer lands. */
  private _applyDisplayedPromotions() {
    const promos = this.snapshot?.promotions || this.missingFenderSerial?.promotions || [];
    const fspId = environment.product_ids.fsp8pro;
    this.displayedPromotions = this.discordGift.canClaimFreeFsp ? promos.filter((p: any) => p.offer_product?.product?.id != fspId) : promos;
  }

  initView(id) {
    this.bundledProducts = [];
    this.loading = true;
    this.licenses = undefined;
    this.hasExtrasOrOffers = false;
    this.productDescriptionHtml = "";
    this.productService.products$
      .pipe(
        filter((result) => !!result),
        take(1)
      )
      .subscribe((result) => {
        this.listProduct = this.productService.listProductDataMap[id];
        if (this.listProduct || id == environment.product_ids.uc) {
          this.userService.subDetails$
            .pipe(
              filter((item) => !!item),
              take(1)
            )
            .subscribe((result) => {
              if (this.listProduct?.stringId == "studioapp7.pro" && this.userService.subDetails?.active && this.userService.subDetails?.subscription?.Asset_id) {
                if (!this.listProduct?.assetIds) this.listProduct.assetIds = [];
                this.listProduct.assetIds.push(this.userService.subDetails.subscription.Asset_id);
              }

              if (this.listProduct && this.eligibleFsAmpPackStringIds.includes(this.listProduct.stringId)) {
                this.shouldShowFsAmpPackCallout = true;
              }
              if (this.listProduct && this.eligibleFsAmpPackStringIdsWithDateRestriction.includes(this.listProduct.stringId)) {
                let startDate = new Date("2026-03-11");
                let endDate = new Date("2026-05-31");
                if (new Date() >= startDate && new Date() <= endDate) {
                  this.shouldShowFsAmpPackCallout = true;
                }
              }
              if (this.listProduct?.assetIds) {
                this.loadingLicenses = true;
                this.productService.getDetailForAssetIds(id, this.listProduct.assetIds).subscribe((result) => {
                  this.loadingLicenses = false;
                  this.gotLicenses$.next(true);
                  this.processLicenses(result);
                });
              } else {
                this.gotLicenses$.next(true);
                this.licenses = [];
              }
            });
          this.productService.getProductSnapshot(id, this.listProduct?.fallbackVersion || null, undefined, this.listProduct?.isMissingFenderSerial ? this.listProduct.serial : undefined).subscribe({
            next: (result: any) => {
              if (result.serial) {
                this.loading = false;
                this.missingFenderSerial = result;
                this._applyDisplayedPromotions();
                this.displaySerialNumber = this.missingFenderSerial.serial.split("#")[1];
                this.title = this.missingFenderSerial.productName;

                // Fire Product Viewed for MissingFenderSerial fallback registration flow (only in My Fender)
                // Use snapshot if available, otherwise create minimal snapshot from MissingFenderSerial data
                if (result.snapshot?.product) {
                  this.fireProductViewedFromSnapshot(result.snapshot);
                } else if (this.userService.appId === "fender") {
                  // Create minimal ProductSnapshot for Product Viewed event when snapshot is not available
                  const minimalSnapshot: ProductSnapshot = {
                    product: {
                      id: this.listProduct?.id || 0,
                      title: result.productName || this._translate.instant("product_detail.fallback_product_name"),
                      categoryId: this.listProduct?.categoryId || "software",
                      stringId: this.listProduct?.stringId || "",
                      imageUrl: "",
                      children: [],
                      platform: "",
                      installMethod: "",
                      productLevel: "",
                    },
                    firmware: [],
                  };
                  this.fireProductViewedFromSnapshot(minimalSnapshot);
                }
              } else {
                this.snapshot = result;
                this._applyDisplayedPromotions();
                this.galleryImages = [];
                this.mainImageUrl = undefined;
                this.productDescriptionHtml = this.resolveDescriptionHtml();
                // Start collapsed for each product (this runs again on in-page product→product nav).
                this.descriptionExpanded = false;
                this.descriptionOverflowing = false;
                this.title = this.snapshot.product.title;
                this.subTitle = undefined;
                if (this.snapshot.missingFenderSerialData) {
                  this.displaySerialNumber = this.snapshot.missingFenderSerialData.serial.split("#")[1];
                }
                // Genuine Fender/FMIC-only snapshots (product.id is the SKU, not a real Product
                // row — see [[fmic-products-api]]) have no MySQL Product.title of their own, so
                // their title/subtitle borrow from PIM's Series/Color. Real products (id < 10000)
                // keep their own Product.title/description untouched.
                const isFenderOnlySnapshot = Number(this.snapshot.product?.id) >= 10000;
                if (isFenderOnlySnapshot && this.snapshot.pimSpecs?.general?.Series) {
                  this.title = this.snapshot.pimSpecs.general.Series;
                  if (this.snapshot.pimSpecs.body?.["Body Shape"]) this.title += " " + this.snapshot.pimSpecs.body["Body Shape"];
                }
                if (isFenderOnlySnapshot && this.snapshot.pimSpecs?.general?.Color) {
                  this.subTitle = this.snapshot.pimSpecs.general.Color;
                  if (this.snapshot.pimSpecs.body?.["Body Finish"]) this.subTitle += ", " + this.snapshot.pimSpecs.body["Body Finish"];
                }
                // Spec table + highlights are otherwise brand-agnostic — any PIM section with a
                // `Name` renders, regardless of whether it came from Fender or PreSonus PIM data.
                this.allSpecs = [];
                if (this.snapshot.pimSpecs) {
                  for (const key in this.snapshot.pimSpecs) {
                    const section = (this.snapshot.pimSpecs as any)[key];
                    if (section && typeof section === "object" && !Array.isArray(section) && section.Name) {
                      this.allSpecs.push(section);
                    }
                  }
                }
                this.highlights = Array.isArray(this.snapshot.pimSpecs?.Highlights) ? this.buildHighlightsFromSpecs(this.snapshot.pimSpecs.Highlights) : undefined;
                this.loadCrossSellProducts();
                // If the user is browsing in another language and there's no admin-authored
                // localized description, overlay localized PIM copy (read-only) for this product.
                this.maybeApplyLocalizedPim();
                if (this.snapshot.product.version) this.productPointVersion = this.snapshot.product.version.split(".")[1];
                if (this._route.snapshot.queryParams["showSplash"]) {
                  this.fbService.checkForSplash(this.snapshot.product.stringId).then((result) => {
                    if (result) this.showSplash(result);
                  });
                  this.router.navigate([], {
                    queryParams: { showSplash: null },
                    queryParamsHandling: "merge",
                  });
                }
                this.loading = false;
                this.product = this.productService.getProduct(id);
                if (this.product) {
                  this.productImage = this.snapshot.product.imageUrl;
                  this.s1OrNotion =
                    this.snapshot.product.categoryId == "software" && (this.snapshot.product.stringId.indexOf("studioapp") > -1 || this.snapshot.product.licenseScheme == 1) ? true : false;
                  this.isS15 = this.snapshot.product.erpId && this.snapshot.product.erpId.indexOf("STUDIOONE5") > -1;
                  this.isS16 = this.snapshot.product.erpId && this.snapshot.product.erpId.indexOf("STUDIOONE6") > -1;
                  this.isS17 = this.snapshot.product.erpId && this.snapshot.product.erpId.indexOf("STUDIOONEPRO7") > -1;
                  this.isS17 = this.snapshot.product.erpId && this.snapshot.product.erpId.indexOf("STUDIOONEPRO7") > -1;
                  this.isFSP8 = this.snapshot.product.stringId && (this.snapshot.product.stringId.indexOf("studioapp8.pro") > -1 || this.snapshot.product.stringId.indexOf("studioapp8.demo") > -1);
                  this.isFenderStudio = this.snapshot.product.stringId && this.snapshot.product.stringId.indexOf("fenderstudio1") > -1;
                  this.isNotionMobile = this.snapshot.product.stringId && this.snapshot.product.stringId.indexOf("notionmobile3") > -1;
                  // this.setup();
                } else {
                  this.productService.getProducts().subscribe((data: any) => {
                    this.product = this.productService.getProduct(id);
                    // this.setup();
                  });
                }
                this.productImage = this.snapshot.product.imageUrl;
                const pimGalleryUrls = this.snapshot.images ? this.helperService.buildImageRows(this.snapshot.images as any).flatMap((row) => row.urls) : [];
                this.galleryImages = Array.from(new Set([this.productImage, ...pimGalleryUrls].filter((url): url is string => !!url)));
                this.mainImageUrl = this.galleryImages[0];
                this.s1OrNotion =
                  this.snapshot.product.categoryId == "software" && (this.snapshot.product.stringId.indexOf("studioapp") > -1 || this.snapshot.product.licenseScheme == 1) ? true : false;
                if (this.snapshot.product.installMethod && this.snapshot.product.installMethod != "none") {
                  this.installMethods = this.snapshot.product.installMethod.split("-");
                  this.installMethods.reverse();
                }

                this.gotLicenses$
                  .pipe(
                    filter((item) => !!item),
                    take(1)
                  )
                  .subscribe((result) => {
                    if (result) {
                      this.hasExtrasOrOffers = this.checkExtrasOrOffers();
                      this.handleDownloads();
                    }
                  });

                if (this.snapshot.product.partnerName == "third_party" && !this.snapshot.product.partnerKey) this.showKeyActions = false;
                if (this.snapshot.product.stringId == "fenderstudio1" || this.snapshot.product.stringId == "fendertone6") this.showKeyActions = true;
                this.resources = {};
                // if (this.snapshot && this.snapshot.accessories && this.snapshot.accessories.length) this.resources.accessories = this.snapshot.accessories;
                this.resourcesSections = [];
                if (this.snapshot.videos && this.snapshot.videos.length) {
                  this.resourcesSections.push({
                    value: "videos",
                    displayed: false,
                  });
                }
                if (this.snapshot.lessons && this.snapshot.lessons.length) {
                  this.resourcesSections.push({
                    value: "lessons",
                    displayed: false,
                  });
                }
                for (let i in this.resources) {
                  this.resourcesSections.push({
                    value: i,
                    displayed: false,
                  });
                }
                this.displayResourceSection(this.resourcesSections[0]);
                this.loading = false;
                this.win.setTimeout(() => {
                  this.measureUI();
                  this.measureDescriptionOverflow();
                }, 10);

                if (this.hashFragment && this.hashFragment.indexOf("downloads_") > -1) {
                  this.win.setTimeout(() => {
                    let inputContainerEl = document.getElementById("product-downloads");
                    if (inputContainerEl && inputContainerEl.scrollIntoView) {
                      inputContainerEl.scrollIntoView({
                        behavior: "smooth",
                      });
                      if (this.productDownloads && this.productDownloads.displayDownloadSection) this.productDownloads.displayDownloadSection(false, this.hashFragment.split("downloads_")[1]);
                    }
                  }, 800);
                }

                // Fire Product Viewed for product detail pages (only in My Fender)
                // This ensures Product Viewed fires instead of Loaded a Page for product routes
                this.fireProductViewedFromSnapshot(this.snapshot);

                if (this.userService.appId !== "fender") {
                  // Non-Fender apps use different Product Viewed format
                  this.avoService.avoInitted$
                    .pipe(
                      filter((result) => !!result),
                      take(1)
                    )
                    .subscribe((result) => {
                      const productId = this.snapshot.product.id.toString();
                      const sku = this.snapshot.product.id.toString();
                      const categoryTag = this.snapshot.product.categoryId?.toString() ?? "";
                      const locale = (this.user?.language_code || "en") + "-" + (this.user?.country || "US");
                      this.avoService.trackEvent().productViewed({
                        siteId: "my_fender",
                        name: this.snapshot.product.title,
                        locale,
                        productId,
                        category: categoryTag ? categoryTag : undefined,
                        sku,
                      });
                    });
                }
                this.fbService.handleFirestorePromise(() => {
                  return this.fbService.doc(`user_metadata/${this.user.id}`).set(
                    {
                      products_seen: {
                        [this.snapshot.product.id]: true,
                      },
                    },
                    { merge: true }
                  );
                });
                if (!this.userService.userMetadata) {
                  this.userService.userMetadata = {
                    products_seen: {},
                  };
                } else if (!this.userService.userMetadata.products_seen) {
                  this.userService.userMetadata.products_seen = {};
                }
                this.userService.userMetadata.products_seen[this.snapshot.product.id] = true;

                if (this._route.snapshot.queryParams["upgrade"]) {
                  let upgradeProduct: boolean = JSON.parse(this._route.snapshot.queryParams["upgrade"]);
                  if (upgradeProduct) {
                    if (this._route.snapshot.queryParams["coupon"]) {
                      this.couponParam = this._route.snapshot.queryParams["coupon"];
                    }
                    this.showUpgrade(this.product);
                  }
                }
              }

              window.scrollTo(0, 0);
            },
            error: (error) => {
              this.loading = false;
              this.appService.alertError(error);
              this.helperService.goBack();
            },
          });
        } else {
          this.goBack();
        }
      });
  }

  /**
   * Store the licenses returned from `getDetailForAssetIds` and derive optionCards /
   * bundledProducts from them. The PAE `product/detail/:id` endpoint returns a licenses
   * *array* only when real assetIds are supplied; when `listProduct.assetIds` is an empty
   * (but truthy) array the request goes out as `?assetIds=` and the endpoint responds with a
   * single detail *object* instead. That object used to be assigned straight to `this.licenses`
   * and then iterated with `.forEach` (here) and the template's `@for (license of licenses)`,
   * crashing the whole product page. Normalize to an array so both paths stay safe.
   * Regression: Bugsnag 6aa0ec9e ("this.licenses.forEach is not a function") /
   * 6aa0eb17 ("g[Symbol.iterator] is not a function") on /products/detail/1790.
   */
  processLicenses(result: any) {
    this.licenses = Array.isArray(result) ? result : [];
    this.optionCards = [];

    this.licenses.forEach((item) => {
      if (item.bundledProducts && item.bundledProducts.length) {
        item.bundledProducts.forEach((bundleItem: any) => {
          if (bundleItem.title.toLowerCase().indexOf("card") > -1) {
            bundleItem.parentSerial = item.hardwareSerialNumber;
            bundleItem.parentLicenseId = item.licenseId;
            this.optionCards.push(bundleItem);
          } else {
            if (!this.productService.productsByStringIDs[bundleItem.stringId] && bundleItem.categoryId != "hardware") bundleItem.redeemable = true;
          }
        });
        this.bundledProducts = item.bundledProducts.filter((item) => item.title.toLowerCase().indexOf("card") == -1);
      }
      if (item.oemItems && item.oemItems.length) this.hasThirdPartyKeys = true;
      if (item.activations && item.activations.length) item.activations[0].computerName = encodeURIComponent(item.activations[0].comment);
      if (!item.upgraded) this.shouldShowSphereRedeem = true;
    });
  }

  // "Installers" is handled entirely by the sticky sidebar's <myp-installer-buttons> (current
  // install + its own "More versions" modal, via softwareDownloads); "Soundsets" gets its own
  // dedicated <myp-bundled-downloads> section below, sourced from the same downloadableContent
  // group — showing it here too would duplicate it.
  private static readonly EXCLUDED_TAB_TYPES = new Set(["Installers", "Soundsets"]);

  /**
   * Assemble `downloads` (grouped by section) and `downloadSections` directly from
   * `snapshot.downloadableContent` — the backend's already-merged, already de-duplicated view
   * over the legacy CMS buckets and PIM. Replaces manually spreading `snapshot.downloads` and
   * filtering `snapshot.firmware` by hand (downloadableContent's Firmware group already drops
   * raw .img files). The brand-specific synthetic manual tiles (Notion Mobile, Studio One,
   * Fender Studio Pro/Studio) are frontend-only content with no backend equivalent — they stay
   * exactly as before, just layered onto the "Owners Manuals" group instead of the legacy
   * `owners_manuals` bucket.
   */
  handleDownloads() {
    const downloads: any = {};
    const groups: Array<{ type: string; content: any[] }> = this.snapshot.downloadableContent || [];
    for (const group of groups) {
      if (ProductDetailComponent.EXCLUDED_TAB_TYPES.has(group.type) || !group.content?.length) continue;
      downloads[group.type] = group.content;
    }
    if (downloads["Firmware"]?.length && this.licenses?.length) {
      downloads["Firmware"].forEach((item: any) => (item.licenseId = this.licenses[0].licenseId));
    }
    this.downloads = downloads;
    this.downloadSections = [];
    if (!downloads["Owners Manuals"]) downloads["Owners Manuals"] = [];

    const notionManualLocales = ["en", "fr", "de", "es", "it", "pt", "ja", "ko", "zh"];
    const localeToLanguageCode = { ja: "jp", zh: "cn" };
    const getLanguageLabel = (locale: string): string => {
      const languageCode = localeToLanguageCode[locale] || locale;
      const languageOption = this.helperService.languages.find((lang) => lang.code === languageCode);
      return languageOption?.name || locale.toUpperCase();
    };

    if (this.isNotionMobile) {
      downloads["Owners Manuals"] = downloads["Owners Manuals"].filter((item) => {
        const combinedText = `${item?.title || ""} ${item?.tileTitle || ""} ${item?.filename || ""} ${item?.url || ""}`.toLowerCase();
        const isLegacyNotionManual = combinedText.includes("notionmobilemanual.presonus.com") || combinedText.includes("notion mobile");
        const isPdf = (item?.filename || "").toLowerCase().endsWith(".pdf") || (item?.url || "").toLowerCase().endsWith(".pdf");
        return !(isLegacyNotionManual || (combinedText.includes("notion") && isPdf));
      });

      const notionManualTiles = notionManualLocales.map((locale) => {
        const title = `Fender Notion ${getLanguageLabel(locale)} Reference Manual`;
        return {
          url: `https://fendernotionmanual.fender.com/${locale}`,
          title,
          tileTitle: title,
          type: "link",
        };
      });
      downloads["Owners Manuals"].unshift(...notionManualTiles);
    }

    if (this.isS15 || this.isS16 || this.isS17) {
      downloads["Owners Manuals"].unshift({
        url: "https://s1manual.presonus.com",
        title: "Studio One Online Manual",
        tileTitle: "Studio One",
        type: "link",
      });
    }

    if (this.isFSP8) {
      const supportedManualLocales = ["en", "fr", "de", "es", "it", "pt", "ja", "ko", "zh"];
      supportedManualLocales.forEach((locale) => {
        downloads["Owners Manuals"].unshift({
          url: `https://fenderstudiopromanual.fender.com/${locale}`,
          title: `${this._translate.instant("fender_studio_pro_8")} ${getLanguageLabel(locale)} ${this._translate.instant("general.reference_manual")}`,
          tileTitle: this._translate.instant("fender_studio_pro_8"),
          type: "link",
        });
      });
    }

    if (this.isFenderStudio) {
      const supportedManualLocales = ["en", "fr", "de", "es", "it", "pt", "ja", "ko", "zh"];
      supportedManualLocales.forEach((locale) => {
        downloads["Owners Manuals"].unshift({
          url: `https://fenderstudiomanual.fender.com/${locale}`,
          title: `${this._translate.instant("fender_studio")} ${getLanguageLabel(locale)} ${this._translate.instant("general.reference_manual")}`,
          tileTitle: this._translate.instant("fender_studio"),
          type: "link",
        });
      });
    }

    for (const key of Object.keys(downloads)) {
      if (downloads[key]?.length) this.downloadSections.push({ value: key, displayed: false, label: key });
    }

    this.displayDownloadSection(this.downloadSections[0]);
  }

  private fireSamplePlayerCta() {
    if (this.userService.appId !== "fender") return;
    const te = this.avoService.trackEvent();
    if (!te || typeof (te as any).ctaClicked !== "function") return;
    this.avoService.avoInitted$
      .pipe(
        filter((v) => !!v),
        take(1)
      )
      .subscribe(() => {
        const page = this.avoService.getPageProperties({ pageName: "Product Detail" });
        const extra: Record<string, any> = {
          ctaText: "Sample player",
          ctaLocation: "Product Detail",
          utmId: (page as any).utmId ?? 0,
          utmTerm: (page as any).utmTerm ?? "",
        };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        (te as any).ctaClicked(payload);
      });
  }

  playSample(smp, i?) {
    this.fireSamplePlayerCta();
    let playlistFiles = [];
    this.snapshot.samples.forEach((item) => {
      playlistFiles.push({
        url: item.url,
        filename: item.title,
        id: item.id,
      });
    });
    this.eventBusService.emit(this.eventBusService.types.playAudio, {
      url: smp.url,
      filename: smp.title,
      id: smp.id,
      playlist: playlistFiles,
    });
  }

  imageClick() {
    this.fbService.checkForSplash(this.snapshot.product.stringId).then((result) => {
      if (result) this.showSplash(result);
    });
  }

  onMainImageClick() {
    this.imageClick();
    this.openGalleryAt(this.mainImageUrl);
  }

  openGalleryAt(url: string) {
    if (!this.galleryImages.length) return;
    const index = this.galleryImages.indexOf(url);
    this.eventBusService.emit(this.eventBusService.types.viewFullscreenImage, { images: this.galleryImages, index: index >= 0 ? index : 0 });
  }

  goBack() {
    this.helperService.goBack();
  }

  checkExtrasOrOffers(): boolean {
    // Check for any licenses with offers
    if (Array.isArray(this.licenses)) {
      if (this.licenses.some((license) => license.offers && license.offers.length > 0)) {
        return true;
      }
    }
    if (this.snapshot) {
      // Check for redeemable products based on product IDs
      if (this.snapshot.product.stringId === "studioapp4.pro") {
        if (!this.productService.productsByStringIDs["presonus.ampire"] || !this.productService.productsByStringIDs["presonus.fatchannel"]) {
          return true;
        }
      }
    }

    // Any other conditions that might show content can be added here

    return false; // Return false if none of the conditions are met
  }

  buy() {
    this.appService.goToCheckout("/checkout?checkoutProductType=Perpetual");
  }

  showSplash(splash) {
    const modalRef = this.appService.showModal(RegisterSuccessSplashComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
    modalRef.componentInstance.splash = splash;
    modalRef.componentInstance.productId = this.snapshot.product.id;
    modalRef.componentInstance.productName = this.snapshot.product.title;
  }

  copyLink(video, event) {
    this._clipboardService.copy(environment.fenderUrl + "content/productvideos/" + this.snapshot.product.stringId + "/" + video.service_id_videos);
    event.stopPropagation();
  }

  copyThirdPartyKey(keyValue: string, parent: ProductLicenseItem, item: any) {
    if (!keyValue) return;
    const id = `${parent?.licenseId ?? "unknown"}:${item?.stringId ?? "unknown"}`;
    this._clipboardService.copy(keyValue);
    this.copiedThirdPartyKeyId = id;
    this.win.setTimeout(() => {
      if (this.copiedThirdPartyKeyId === id) this.copiedThirdPartyKeyId = null;
    }, 1500);
  }

  copyLicenseKey(keyValue: string, license: ProductLicenseItem) {
    if (!keyValue) return;
    const id = `${license?.licenseId ?? "unknown"}`;
    this._clipboardService.copy(keyValue);
    this.copiedLicenseKeyId = id;
    this.win.setTimeout(() => {
      if (this.copiedLicenseKeyId === id) this.copiedLicenseKeyId = null;
    }, 1500);
  }

  showVideo(video) {
    this.eventBusService.emit(this.eventBusService.types.playVideo, {
      id: video.service_id_videos,
      title: video.title_videos,
      type: "youtube",
      thumb: video.thumb_videos,
    });
  }

  videoClosed() {
    this.selectedVideo = undefined;
  }

  private fireDeregisterCta() {
    if (this.userService.appId !== "fender") return;
    const te = this.avoService.trackEvent();
    if (!te || typeof (te as any).ctaClicked !== "function") return;
    this.avoService.avoInitted$
      .pipe(
        filter((v) => !!v),
        take(1)
      )
      .subscribe(() => {
        const page = this.avoService.getPageProperties({ pageName: "Product Detail" });
        const extra: Record<string, any> = {
          ctaText: "Deregister",
          ctaLocation: "Product Detail",
          utmId: (page as any).utmId ?? 0,
          utmTerm: (page as any).utmTerm ?? "",
        };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        (te as any).ctaClicked(payload);
      });
  }

  removeHardware(item) {
    this.appService.confirm(this._translate.instant("product_detail.confirm_remove_hardware")).then((result) => {
      if (result) {
        this.fireDeregisterCta();
        if (item.isMissingFenderSerial) {
          this._spin.show();
          this.productService.deleteMissingFenderSerial(item.serial).subscribe((result) => {
            this.productService.getProducts(true).subscribe((products) => {
              this._spin.hide();
              this.router.navigate(["products/all"], <NavigationExtras>{
                skipLocationChange: true,
              });
            });
          });
        } else {
          this.productService.deregisterHardware(item.licenseId, true).subscribe((result) => {
            this.productService.getProducts(true).subscribe((products) => {
              this._spin.hide();
              this.router.navigate(["products/all"], <NavigationExtras>{
                skipLocationChange: true,
              });
            });
          });
        }
      }
    });
  }

  /**
   * Fire Product Viewed event from a ProductSnapshot (shared helper for normal and MissingFenderSerial paths).
   * Only runs when userService.appId === 'fender'.
   */
  private fireProductViewedFromSnapshot(snapshot: ProductSnapshot) {
    if (this.userService.appId !== "fender") return;
    this.avoService.avoInitted$
      .pipe(
        filter((result) => !!result),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe((result) => {
        const productId = snapshot.product.id.toString();
        const sku = snapshot.product.id.toString();
        const categoryTag = snapshot.product.categoryId?.toString() ?? "";
        const page = this.avoService.getPageProperties({ pageName: "Product Detail" });
        const extra = {
          name: snapshot.product.title ?? undefined,
          products: [
            {
              currency: "USD",
              price: 0,
              quantity: 1,
              sku,
              variant: "",
              category: categoryTag,
              position: 0,
              productName: snapshot.product.title ?? "",
              productId,
              upsell: false,
            },
          ],
          categoryTag: categoryTag || "product",
        };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        this.avoService.trackEvent().productViewed(payload);
      });
  }

  private fireOfflineActivationCta() {
    if (this.userService.appId !== "fender") return;
    const te = this.avoService.trackEvent();
    if (!te || typeof (te as any).ctaClicked !== "function") return;
    this.avoService.avoInitted$
      .pipe(
        filter((v) => !!v),
        take(1)
      )
      .subscribe(() => {
        const page = this.avoService.getPageProperties({ pageName: "Product Detail" });
        const extra: Record<string, any> = {
          ctaText: "Offline Activation",
          ctaLocation: "Product Detail",
          utmId: (page as any).utmId ?? 0,
          utmTerm: (page as any).utmTerm ?? "",
          userId_: this.user?.["fc-id"] ?? undefined,
          fcId: this.user?.["fc-id"] ?? undefined,
        };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        (te as any).ctaClicked(payload);
      });
  }

  /**
   * Downloads the offline license file for the selected license. Software (JWT) licenses are bound
   * to their first activation; extensions download by license id alone.
   */
  downloadLicense(withActivation: boolean) {
    const license = this.selectedLicense;
    if (!license || this.downloadingLicense) return;
    const activation = withActivation
      ? { computerKey: license.activations?.[0]?.activationCode, computerName: license.activations?.[0]?.computerName, productKey: license.productKeyString }
      : undefined;
    this.downloadingLicense = true;
    this.productService.downloadLicenseFile(this.user.id, license.licenseId, activation).subscribe({
      next: (blob: Blob) => {
        this.downloadingLicense = false;
        saveAs(blob, withActivation ? "Presonus.license" : "PreSonus.license");
      },
      error: async (error) => {
        this.downloadingLicense = false;
        let message = "";
        try {
          const text: string =
            error?.error instanceof Blob
              ? await new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(String(reader.result ?? ""));
                  reader.onerror = () => reject(reader.error);
                  reader.readAsText(error.error);
                })
              : "";
          try {
            message = JSON.parse(text)?.message || "";
          } catch {
            message = text;
          }
        } catch {}
        this.appService.alert(message || "Sorry, we couldn't download your license file. Please try again.");
      },
    });
  }

  showActivateOffline(license) {
    this.fireOfflineActivationCta();
    const modalRef = this.appService.showModal(ActivateOfflineComponent, { size: "sm" });
    modalRef.componentInstance.license = license;
    modalRef.componentInstance.activationCompleted.subscribe((result) => {
      if (result) {
        this.initView(this.listProduct.id);
      }
    });
  }

  showMoreVideos() {
    this.router.navigate(["learn/videos/search"], { queryParams: { product: this.snapshot.product.stringId } });
  }

  showFspRedeem() {
    const modalRef = this.appService.showModal(StudiooneGracePeriodComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
  }

  downloadHub() {
    if (this.productService.productsByStringIDs["presonushub"]) {
      this.productService.getProductSnapshot(environment.product_ids.studiohub.toString()).subscribe((snapshot: ProductSnapshot) => {
        const installer = this.helperService.getInstallerForCurrentOs(snapshot?.softwareDownloads, snapshot?.product?.title, this.appService.os);
        if (installer) {
          window.open(installer.url);
        } else {
          this.appService.alertError(this._translate.instant("products.no_installers_available"));
        }
      });
    } else {
      this.productService.redeemProduct({ id: 986 }).subscribe((result) => {
        if (result.product) {
          const hubSnapshot = result.product?.product?.product;
          const installer = this.helperService.getInstallerForCurrentOs(hubSnapshot?.softwareDownloads, hubSnapshot?.product?.title, this.appService.os);
          if (installer) {
            this._getTokenizedInstaller(installer);
          } else {
            this.appService.alertError(this._translate.instant("products.no_installers_available"));
          }
          this.productService.getProducts(true).subscribe();
        }
      });
    }
  }

  private _getTokenizedInstaller(dl) {
    if (dl.tokenized) {
      this.productService.getTokenizedUrl(dl.folder, dl.fileName, "my_fender", dl.title, dl.id.toString(), dl.fileName, parseInt(dl.contentLength), dl.version || dl.version_number).subscribe({
        next: (result: any) => {
          window.open(result.url);
        },
        error: (error) => {
          this.appService.alertError(error);
        },
      });
    } else {
      window.open(dl.url);
    }
  }

  private fireTransferLicenseCta() {
    if (this.userService.appId !== "fender") return;
    const te = this.avoService.trackEvent();
    if (!te || typeof (te as any).ctaClicked !== "function") return;
    this.avoService.avoInitted$
      .pipe(
        filter((v) => !!v),
        take(1)
      )
      .subscribe(() => {
        const page = this.avoService.getPageProperties({ pageName: "Product Detail" });
        const extra: Record<string, any> = {
          ctaText: "Transfer License",
          ctaLocation: "Product Detail",
          utmId: (page as any).utmId ?? 0,
          utmTerm: (page as any).utmTerm ?? "",
          userId_: this.user?.["fc-id"] ?? undefined,
          fcId: this.user?.["fc-id"] ?? undefined,
        };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        (te as any).ctaClicked(payload);
      });
  }

  showTransferLicense(item) {
    this.fireTransferLicenseCta();
    this.appService.goToCheckout(`/checkout?checkoutProductType=Transfer&assetId=${item.licenseId}&productId=${this.snapshot.product.id}`);
  }

  showUpgrade(item) {
    const modalRef = this.appService.showModal(UpgradeSoftwareComponent, { size: "md" });
    modalRef.componentInstance.upgradingProduct = {
      ...this.snapshot.product,
      license: item,
    };
  }

  showManageActivations(item) {
    if (item.activations?.length && this.snapshot.product.licenseScheme != 1) {
      const modalRef = this.appService.showModal(ManageActivationsComponent, { size: "lg" });
      modalRef.componentInstance.product = this.snapshot.product;
      modalRef.componentInstance.license = item;
      modalRef.componentInstance.activationDeleted.subscribe((result) => {
        this.initView(this.snapshot.product.id);
      });
    }
  }

  openOffers(item) {
    const modalRef = this.appService.showModal(RedeemHardwareOfferComponent, { size: "lg" });
    modalRef.componentInstance.parentProduct = this.snapshot.product;
    modalRef.componentInstance.offers = item.offers;
    modalRef.componentInstance.license = item;
    modalRef.componentInstance.redeemed.subscribe((result) => {
      this.initView(this._route.snapshot.params["id"]);
    });
  }

  learnMoreGiveaway(giveaway) {
    let modalRef = this.appService.showModal(GenericAlertComponent, { size: "lg" });
    modalRef.componentInstance.title = giveaway.gift.title;
    modalRef.componentInstance.html = `
      <p>${this._translate.instant("product_detail.giveaway.congratulations_message", { productTitle: this.snapshot.product.title, giftTitle: giveaway.gift.title })}</p>
      <p>${this._translate.instant("product_detail.giveaway.next_step")}</p>

      <p>${this._translate.instant("product_detail.giveaway.contact_advisor_message", { giftTitle: giveaway.gift.title })}</p>
      <p>${this._translate.instant("product_detail.giveaway.what_you_need")}</p>
      <ul>
        <li>${this._translate.instant("product_detail.giveaway.proof_of_purchase")}</li>
        <li>${this._translate.instant("product_detail.giveaway.registered_serial")}</li>
      </ul>
      <p>${this._translate.instant("product_detail.giveaway.contact_advisor")}</p>
      <ul>
        <li>${this._translate.instant("product_detail.giveaway.online")}: <a href="https://support.fender.com/hc/en-us/requests/new" target="_blank">https://support.fender.com/hc/en-us/requests/new</a></li>
        <li>${this._translate.instant("product_detail.giveaway.email")}: <a href="mailto:contactemea@fender.com">contactemea@fender.com</a></li>
      </ul>
      <em class="t-12">${this._translate.instant("product_detail.giveaway.limited_offer")}</em>
    `;
  }

  displayDownloadSection(section) {
    if (this.downloadSections.length) {
      this.downloadSections.forEach((item) => {
        item.displayed = false;
      });
      section.displayed = true;
      this.displayedDownloadSection = section;
    }
  }

  displayResourceSection(section) {
    if (this.resourcesSections.length) {
      this.resourcesSections.forEach((item) => {
        item.displayed = false;
      });
      section.displayed = true;
      this.displayedResourcesSection = section;
    }
  }

  getOemKey(parent, item) {
    let args = {
      assetId: parent.licenseId,
      oemId: item.stringId,
    };
    item.loading = true;
    this.productService.getOemKey(args).subscribe((oemResult: GetOemKeyResponse) => {
      if (oemResult.data) item.data = oemResult.data;
      this.productService.getProducts(true).subscribe((result) => {
        item.loading = false;
      });
    });
  }

  addOptionCard() {
    let regInProcessString;
    this._translate.get("products.register.registration_in_process").subscribe((string) => {
      regInProcessString = string;
    });
    const modalRef = this.appService.showModal(RegisterProductComponent, {
      size: "lg",
      ariaLabelledBy: "modal-title",
      beforeDismiss: () => {
        if (modalRef.componentInstance.registering) {
          alert(regInProcessString);
          return false;
        }
      },
    });
    let asset_ids = [];
    this.licenses.forEach((item: any) => {
      asset_ids.push({
        serial: item.hardwareSerialNumber,
        asset_id: item.licenseId,
      });
    });
    modalRef.componentInstance.optionCardOptions = {
      asset_ids: asset_ids,
    };
    modalRef.componentInstance.productRegistered.subscribe((result) => {
      // this.setup(true);
      this.initView(this.snapshot.product.id);
    });
    modalRef.result.then(
      (result) => {},
      (error) => {}
    );
  }

  optionCardInstructions(card) {
    const modalRef = this.appService.showModal(FirmwareInstructionsComponent, { size: "lg" });
    modalRef.componentInstance.optionCard = card;
  }

  public removingOptionCard: boolean = false;
  deregisterOptionCard(card) {
    this._translate.get("product_detail.option_cards.confirm_remove").subscribe((string) => {
      this.win.confirm(string).then(
        (_) => {
          this.fireDeregisterCta();
          this.removingOptionCard = true;
          this.productService.deregisterHardware(card.assetIds[0], true).subscribe((result) => {
            this.removingOptionCard = false;
            this.initView(this.snapshot.product.id);
          });
        },
        (error) => {
          // console.log(error);
        }
      );
    });
  }

  tileClick(prod) {
    let id = prod.id;
    if (prod.productId) id = prod.productId;
    this.router.navigate(["products/detail/", id]);
  }

  /**
   * Resolve the SKUs in `pimSpecs.CrossSell` (attached by the FMIC snapshot builder — see
   * [[fmic-products-api]]) to lightweight list items for the "you might also like" rail.
   * Best-effort: if the lookup fails or there's no cross-sell data, the rail simply stays hidden.
   */
  loadCrossSellProducts() {
    this.crossSellBuckets = [];
    this.displayedCrossSellBucket = undefined;
    const crossSell = this.snapshot?.pimSpecs?.CrossSell;
    if (!Array.isArray(crossSell) || !crossSell.length) return;
    // Build a normalized-SKU -> relationshipType map (SKUs may differ in zero-padding between
    // the CrossSell entry and the resolved product), and remember the order types first appear.
    const normalize = (s: any) =>
      String(s ?? "")
        .trim()
        .replace(/^0+/, "");
    const skuType: { [sku: string]: string } = {};
    const typeOrder: string[] = [];
    const skus: string[] = [];
    for (const entry of crossSell as any[]) {
      const sku = entry?.relatedSkuNumber != null ? String(entry.relatedSkuNumber).trim() : "";
      if (!sku) continue;
      const type = (entry?.relationshipType || "Other").toString().trim() || "Other";
      // TODO: TEMPORARY hotfix (2026-09-27) hiding the "Replaced By" tab. To restore it, delete this
      // line and the "TEMPORARY: Replaced By hidden" tests in product-detail.component.spec.ts.
      if (/^replaced\s*by$/i.test(type)) continue;
      const key = normalize(sku);
      if (!(key in skuType)) {
        skuType[key] = type;
        skus.push(sku);
      }
      if (!typeOrder.includes(type)) typeOrder.push(type);
    }
    if (!skus.length) return;
    this.productService
      .getFenderGearBySkus(skus)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (items) => {
          // Shape each item for myp-product-tile (title/imageUrl/shortDescription); keep shopUrl
          // for the click-through. No `id` so the tile doesn't try to route to a local PDP.
          const bucketsByType: { [type: string]: any[] } = {};
          for (const item of items || []) {
            const type = skuType[normalize(item.sku)] || "Other";
            const tile = { title: item.title, imageUrl: item.imageUrl, shortDescription: item.description, shopUrl: item.shopUrl };
            (bucketsByType[type] = bucketsByType[type] || []).push(tile);
          }
          // Suggested Accessories first, then the remaining types in the order they first appeared.
          const orderedTypes = typeOrder.filter((t) => bucketsByType[t]?.length);
          orderedTypes.sort((a, b) => {
            const aAcc = /suggested accessor/i.test(a) ? 0 : 1;
            const bAcc = /suggested accessor/i.test(b) ? 0 : 1;
            if (aAcc !== bAcc) return aAcc - bAcc;
            return typeOrder.indexOf(a) - typeOrder.indexOf(b);
          });
          this.crossSellBuckets = orderedTypes.map((type, i) => ({ type, items: bucketsByType[type], displayed: i === 0 }));
          this.displayedCrossSellBucket = this.crossSellBuckets[0];
        },
        error: () => {
          this.crossSellBuckets = [];
          this.displayedCrossSellBucket = undefined;
        },
      });
  }

  /** Switch the active cross-sell relationshipType tab. */
  displayCrossSellBucket(bucket: { type: string; items: any[]; displayed: boolean }) {
    this.crossSellBuckets.forEach((b) => (b.displayed = b === bucket));
    this.displayedCrossSellBucket = bucket;
  }

  /** Cross-sell tiles link out to the brand storefront search page (shopUrl). */
  openCrossSell(prod: any) {
    if (prod?.shopUrl) window.open(prod.shopUrl, "_blank");
  }

  showiLokOverlay() {
    const modalRef = this.appService.showModal(IlokComponent, { size: "lg" });
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.measureUI();
    this.measureDescriptionOverflow();
  }

  public sidebarWidth: number;
  measureUI() {
    if (this.prodDetailSidebar && this.prodDetailSidebar.nativeElement) {
      this.sidebarWidth = this.prodDetailSidebar.nativeElement.clientWidth - 15;
    }
  }

  public toggleDescription() {
    this.descriptionExpanded = !this.descriptionExpanded;
  }

  // Decides whether the Show more / Show less toggle is needed by comparing the (clamped) rendered
  // height against the full content height. Only meaningful while collapsed, since the clamp is what
  // makes scrollHeight exceed clientHeight; once expanded we leave the toggle in place (Show less).
  private measureDescriptionOverflow() {
    const el = this.prodDescription?.nativeElement;
    if (!el) return;
    if (!this.descriptionExpanded) {
      this.descriptionOverflowing = el.scrollHeight > el.clientHeight + 2;
    }
  }

  private buildHighlightsFromSpecs(highlightsSpec: any): Array<{ description: string; title: string; url: string }> {
    if (!highlightsSpec) return [];
    let entriesArray = Array.isArray(highlightsSpec) ? highlightsSpec : [highlightsSpec];
    if (!entriesArray.length) return [];
    entriesArray = entriesArray.filter((entry) => entry.title.toLowerCase().indexOf("software license") == -1 && entry.title.toLowerCase().indexOf("fender studio pro") == -1);
    // New shape (post-FMIC migration): already grouped as `[{title, description, url}, ...]`.
    // Pass through as-is.
    if (entriesArray[0] && typeof entriesArray[0] === "object" && ("title" in entriesArray[0] || "description" in entriesArray[0] || "url" in entriesArray[0])) {
      return entriesArray.map((h: any) => ({
        title: h.title || "",
        description: h.description || "",
        url: h.url || "",
      }));
    }

    // Legacy flat shape: `[{Highlight1Title: ...}, {Highlight1Description: ...}, ...]`.
    // Group by sequence number prefix.
    const indexToHighlight: Record<string, { description?: string; title?: string; url?: string }> = {};
    entriesArray.forEach((entry: any) => {
      if (!entry || typeof entry !== "object") return;
      const keys = Object.keys(entry);
      if (!keys.length) return;
      const key = keys[0];
      const value = entry[key];
      const match = key && key.match(/^Highlight(\d+)(Description|Title|URL)$/i);
      if (!match) return;
      const index = match[1];
      const field = match[2].toLowerCase();
      if (!indexToHighlight[index]) indexToHighlight[index] = {};
      (indexToHighlight[index] as any)[field] = value;
    });

    return Object.keys(indexToHighlight)
      .sort((a, b) => Number(a) - Number(b))
      .map((idx) => {
        const item = indexToHighlight[idx];
        return {
          description: item.description || "",
          title: item.title || "",
          url: item.url || "",
        };
      });
  }
}
